<template>

  <div>
    <vx-card ref="filterCard" :title="$t('Filtros')" class="mb-2" :collapse-action="true" >

      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">          
        </vs-col> 

        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="11">
          <vx-tooltip :text="$t('Pesquisa')">              
            <vs-button class="mr-2" radius color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
          </vx-tooltip>          
          <vx-tooltip :text="$t('Novo')">              
            <vs-button class="mr-2" radius color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
          </vx-tooltip>          
        </vs-col>
      </vs-row>      
    </vx-card>

     <vx-card>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :headerHeight="25"
        :rowHeight="25"
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>
      
    </vx-card>     
  </div>

</template>

<script>
import axios from "@/axios.js"

import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'

const URL_SERVLET = "/rest/StatusItinerarioViagemCustomizado/Listar";
const NAME_ROUTE_EDIT = "roteirizacao-status-itinerario-customizado-edit";

export default {
  components: {
    AgGridVue
  },
  data() {
    return {     
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'DESCRIÇÃO', field: 'descricao' },
            { headerName: 'CUSTOMIZADA', field: 'descricaoCustomizada' },
            { headerName: 'VISITA', field: 'descricaoParaVisita' },            
            { headerName: 'STATUS PARA VISITA ?', field: 'statusParaVisita' , valueGetter: function(params) { return ( params.data.statusParaVisita ? 'SIM' : '-');   } }
                
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0      
    }
  },  
  computed: {
   
  },
  methods: {    
    fetchLista() {  
      this.$vs.loading(); 
      
      const params = new URLSearchParams();            
      
      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.dadosDaGrid = response.data;              
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro() {
      let self_ = this;
      let registro = {lista: self_.dadosDaGrid };
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    }    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api        
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    this.fetchLista();
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 305px);
  }
</style>